export const QUERY_CONFIG = {
  staleTime: Infinity,
  refetchOnWindowFocus: false,
};
